/*    验证正则
 setTimeout(() => {
    if (isNaN(Number(value))) {
      callback(new Error("请输入数字值"));
    } else {
      callback();
    }
  }, 1000);  判断账号只为数字的情况
  //是否包含数字
var ptr_digit = /^.*[0-9]+.*$/;
//是否包含小写字母
var ptr_lowcase = /^.*[a-z]+.*$/;
//是否包含大写字母
var ptr_upcase = /^.*[A-Z]+.*$/;
//是否包含特殊字符（非数字、字母的字符）
var ptr_special = /((?=[\x21-\x7e]+)[^A-Za-z0-9])/;
*/
// 学习云正则
var PassPatterns = /^[a-zA-Z0-9_]{6,20}$/;
var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
export var checkAge = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("请输入考核云密码"));
  } else if (!PassPatterns.test(value)) {
    callback(new Error("格式错误,6到20位"));
  } else {
    callback();
  }
};
// 新密码正则
//是否包含特殊字符（非数字、字母的字符）
var PassPattern1 = /^[a-zA-Z0-9_]{6,20}$/;
var ptr_special = /((?=[\x21-\x7e]+)[^A-Za-z0-9])/;
export var validatePass = function(obj) {
  return (rule, value, callback) => {
    console.log(value);
    if (value === "") {
      callback(new Error("请输入密码"));
    } else if (!PassPattern1.test(value)) {
      callback(new Error("密码长度不能小于6位字符，不能大于20位字符"));
    } else {
      callback();
    }
  };
};
// 确认密码正则
export var validatePass2 = function(obj) {
  return (rule, value, callback) => {
    if (value === "") {
      callback(new Error("请再次输入密码"));
    } else if (value !== obj.loginForm.password) {
      callback(new Error("两次输入密码不一致!"));
    } else {
      callback();
    }
  };
};

// 修改密码正则
// ^(?!a-zAZ+$)(?![AZ0-9+$)(?![A-Z\\W_+$)(?![a-z0-9]+$)(?![a-z\\W_]+$)(?![0-9\\W_]+$)[a-zA-Z0-9\\W_]{8,20}$
export var ModifyPass = function(obj) {
  return (rule, value, callback) => {
    console.log(value);
    if (value === "") {
      callback(new Error("请输入密码"));
    } else {
      //6-20位包含字符、数字和特殊字符
      var ls = 0;
      if (obj.loginForm.password !== "") {
        if (obj.loginForm.password.match(/([a-zA-Z])+/)) {
          ls++;
        }
        if (obj.loginForm.password.match(/([0-9])+/)) {
          ls++;
        }
        // if (obj.loginForm.password.match(/([A-Z])+/)) {
        //   ls++;   ^[A-Za-z]+$
        // }
        if (
          obj.loginForm.password.match(/([\W])+/) &&
          !obj.loginForm.password.match(/(![\u4E00-\u9FA5])+/)
        ) {
          ls++;
        }
        if (
          obj.loginForm.password.length < 6 ||
          obj.loginForm.password.length > 20
        ) {
          callback(new Error("要求6-20位字符"));
          ls = 0;
        }
        if (obj.loginForm.password.match(/([\u4E00-\u9FA5])+/)) {
          callback(new Error("不能包含中文字符"));
          ls = 0;
        }
        switch (ls) {
          case 0:
            obj.passwordPercent = 0;
            callback(new Error("数字、字母以及特殊字符中三选二"));
            break;
          case 1:
            obj.passwordPercent = 33;
            callback(new Error("数字、字母以及特殊字符中三选二"));
            break;
          // case 2:
          //   obj.passwordPercent = 66;
          //   callback(
          //     new Error("数字、字母以及特殊字符中三选二")
          //   );
          //   break;
          case 3:
          case 4:
            obj.passwordPercent = 100;
            break;
          default:
            obj.passwordPercent = 0;
            break;
        }
      }
      callback();
    }
  };
};
// 确认密码正则
export var ModifyPass2 = function(obj) {
  return (rule, value, callback) => {
    if (value === "") {
      callback(new Error("请再次输入密码"));
    } else if (value !== obj.loginForm.password) {
      callback(new Error("两次输入密码不一致!"));
    } else {
      callback();
    }
  };
};
// 修改独立密码
var PassPattern = /^[a-zA-Z0-9_]{6,16}$/;
export var validationPaw = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("请输入旧独立密码"));
  } else if (!PassPattern.test(value)) {
    callback(new Error("格式错误,6到16位"));
  } else {
    callback();
  }
};
// 撤销独立密码
export var validationUndo = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("请输入独立密码"));
  } else if (!PassPattern.test(value)) {
    callback(new Error("格式错误,6到16位"));
  } else {
    callback();
  }
};
// 修改登陆密码正则
export var UserPass = function(obj) {
  return (rule, value, callback) => {
    console.log(value);
    if (value === "") {
      callback(new Error("请输入密码"));
    } else {
      //6-20位包含字符、数字和特殊字符
      var ls = 0;
      if (obj.userPassword.Password !== "") {
        if (obj.userPassword.Password.match(/([a-zA-Z])+/)) {
          ls++;
        }
        if (obj.userPassword.Password.match(/([0-9])+/)) {
          ls++;
        }
        // if (obj.loginForm.password.match(/([A-Z])+/)) {
        //   ls++;   ^[A-Za-z]+$
        // }
        if (
          obj.userPassword.Password.match(/([\W])+/) &&
          !obj.userPassword.Password.match(/(![\u4E00-\u9FA5])+/)
        ) {
          ls++;
        }
        if (
          obj.userPassword.Password.length < 6 ||
          obj.userPassword.Password.length > 20
        ) {
          callback(new Error("要求6-20位字符"));
          ls = 0;
        }
        if (obj.userPassword.Password.match(/([\u4E00-\u9FA5])+/)) {
          callback(new Error("不能包含中文字符"));
          ls = 0;
        }
        switch (ls) {
          case 0:
            obj.passwordPercent = 0;
            callback(new Error("数字、字母以及特殊字符中三选二"));
            break;
          case 1:
            obj.passwordPercent = 33;
            callback(new Error("数字、字母以及特殊字符中三选二"));
            break;
          // case 2:
          //   obj.passwordPercent = 66;
          //   callback(
          //     new Error("数字、字母以及特殊字符中三选二")
          //   );
          //   break;
          case 3:
          case 4:
            obj.passwordPercent = 100;
            break;
          default:
            obj.passwordPercent = 0;
            break;
        }
      }
      callback();
    }
  };
};
//确认密码
export var UserPass2 = function(obj) {
  return (rule, value, callback) => {
    if (value === "") {
      callback(new Error("请再次输入密码"));
    } else if (value !== obj.userPassword.Password) {
      callback(new Error("两次输入密码不一致!"));
    } else {
      callback();
    }
  };
};
// 试题保护验证密码
export var protectPass = function(obj) {
  return (rule, value, callback) => {
    console.log(value);
    if (value === "") {
      callback(new Error("请输入密码"));
    } else if (obj.Status != 200) {
      callback(new Error("密码错误"));
    } else {
      callback();
    }
  };
};
// 手机号正则
let phonereg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/; //手机号正则式
export var phoneCheck = function(obj) {
  return (rule, value, callback) => {
    if (!value) {
      return callback(new Error("请输入手机号"));
    } else if (!phonereg.test(value)) {
      callback(new Error("请输入正确的手机号"));
    } else {
      // obj.checkusername() // 验证是否注册跟当前手机号
      callback();
    }
  };
};
// 协议
export var agreement = function(obj) {
  return (rule, value, callback) => {
    if (value !== true) {
      return callback(new Error("请阅读并同意卫教云用户协议"));
    } else {
      callback();
    }
  };
};
//
export var zhuanhuan = function(a) {
  a = a.replace(/\[Img/g, "<img src='https://testimages.ksbao.com/tk_img/Img");
  let codeindex = a.lastIndexOf(".");
  a = a.replace(
    a[codeindex - 1],
    "%" + a[codeindex - 1].charCodeAt().toString(16)
  );
  return a.replace(/\]/g, "'>");
};
// 12.14 产品新增密码强度正则 必须满足大写小写数字
const textStrong = /(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d){6,20}/;
export var strongPass = function(obj) {
  return (rule, value, callback) => {
    console.log(value);
    if (value === "") {
      callback(new Error("请输入密码"));
    } else if (value.length < 6 || value.length > 20) {
      //6-20位包含字符、数字和特殊字符
      callback(new Error("请输入6~20位密码"));
    } else if (!textStrong.test(value)) {
      callback(
        new Error("密码必须同时包含大小写字母、数字")
      );
    } else {
      callback();
    }
  };
};
